<template>
  <img :src="content" :aria-label="ariaLabel" :alt="ariaLabel" class="svg-img-icon" />
</template>

<script>
const cache = new Map();
const req = require.context(`${__dirname}/../../assets/icons/`, true, /^\.\/.*\.svg$/);

/**
 * Load svg file as datauri in a img tag.
 *
 * Usage: <svg-img-icon name="deaflix/topics_all" aria-label="Tutti gli argomenti" />
 *
 */
export default {
  name: "SvgImgIcon",

  props: {
    /**
     * The name of the icon to display.
     */
    name: {
      type: String,
      required: true,
      default: "settings",
    },
    /**
     * Descriptive text to be read to screenreaders.
     */
    ariaLabel: {
      type: String,
      default: "icon",
    },
  },
  data() {
    return {
      content: null,
    };
  },
  watch: {
    async name() {
      await this.loadIcon();
    },
  },
  async mounted() {
    await this.loadIcon();
  },
  methods: {
    async loadIcon() {
      const currPath = req(`./${this.name.replace(".svg", "")}.svg`);
      if (!cache.has(currPath)) {
        try {
          cache.set(
            currPath,
            fetch(currPath).then(r => r.text())
          );
        } catch (e) {
          cache.delete(currPath);
        }
      }
      if (cache.has(currPath)) {
        this.content = `data:image/svg+xml;base64,${btoa(await cache.get(currPath))}`;
      }
    },
  },
};
</script>
